import React from 'react';
import styled from 'styled-components'
import Fade from 'react-reveal/Fade';
import { Link } from 'react-router-dom';
function ProjectCard({title,techused,bacimg,linkto}){
  console.log(techused)
  return(<Container>
            <a href={linkto}>
            <div className="col">

            <img src={bacimg}/>


            <div className="layer">
              <h3>{title}</h3>
            </div>
            <div className="layer1">
              <h3>{title}</h3>
              <p>Tech Used:</p>
              <ul>
              <Fade left>
              <li>{techused[0]}</li>
              </Fade>
              <Fade left>
              <li>{techused[1]}</li>
              </Fade>
              <Fade left>
              <li>{techused[2]}</li>
              </Fade>
              <Fade left>
              <li>{techused[3]}</li>
              </Fade>
              </ul>
            </div>
            </div>
              </a>
        </Container>);
}
export default ProjectCard;

const Container = styled.div`
.col{
  cursor: pointer;
  flex-basis: 32%;
border-radius: 10px;
margin-bottom: 30px;
position: relative;
overflow:hidden;
}
  .col img{
    width: 300px;
    height: 200px;
    border-radius:15px;
    display: block;
  }
  margin: 39px;
  .layer{
    position: relative;
    bottom: 43px;
    color: white;
    background-color:black;
    border-radius: 10px;
  }

  .layer1{
    background: transparent;
    height: 200px;
    width: 300px;
    position: absolute;
    top:0;
    left: 0;
    transition: 0.5s;
  }
  .layer1:hover{
    background: rgba(226,0,0,0.7);
  }
 .layer1 h3{
   width: 100%;
  font-weight: 500;
  color:#fff;
  font-size: 26px;
  bottom:0;
  left:50%;
  transform: translate(-50%);
  position:absolute;
  opacity: 0;
  transition: 0.5s;
 }
 .layer1:hover h3{
  bottom: 70%;
  opacity:1;
}
.layer1 p{
  width: 100%;
 font-weight: 300;
 color:#fff;
 font-size: 18px;
 bottom:0;
 left:50%;
 transform: translate(-50%);
 position:absolute;
 opacity: 0;
 transition: 0.5s;
 text-align: left;
 text-decoration:underline;
}
.layer1:hover p{
 bottom: 58%;
 opacity:1;
}
.layer1 ul{
  width: 100%;
 font-weight: 300;
 color:#fff;
 font-size: 18px;
 bottom:0;
 left:50%;
 transform: translateX(-50%);
 position:absolute;
 opacity: 0;
 transition: 0.5s;
 list-style-type:none;
 text-align:left;
}
.layer1:hover ul{
 bottom: 1%;
 opacity:1;
}
`
